import React, { Fragment, useState, useContext } from "react";
import Login from "./Login";
import Signup from "./Signup";
import NewCollage from "./addNewCollage";
import { LayoutContext } from "../index";
const LoginSignup = (props) => {
  const { data, dispatch } = useContext(LayoutContext);
  //const [show,setShow]=useState(false);
  const [login, setLogin] = useState(true);
  const [signUp, setSignUp] = useState(true);
  const [loginValue, setLoginValue] = useState("Create an account");
  const [newCollageValue, setNewCollageValue] = useState(false);

  const loginSignupModalToggle = () =>
    data.loginSignupModal ? dispatch({ type: "loginSignupModalToggle", payload: false }) : dispatch({ type: "loginSignupModalToggle", payload: true });

    const changeLoginSignup = () => {
      if (login) {
        setLogin(false);
        setLoginValue("Login");
        setNewCollageValue(false)
      } else {
        setLogin(true);
        setLoginValue("Create an account");
        setNewCollageValue(false)
      }
    };
    const changeNewCollage=()=>{
      setNewCollageValue(true);
      setLogin(false);
    }
    const NotFromNie = () => {
      setNewCollageValue(true);
    }

  return (
    <Fragment>
      {/* Black Overlay  */}
      <div
        onClick={(e) => loginSignupModalToggle()}
        className={` ${
          data.loginSignupModal ? "" : "hidden"
        } fixed top-0 z-40 w-full h-screen bg-dark opacity-75 cursor-pointer`}
      ></div>
      {/* Signup Login Component Render */}
      <section
        className={` ${
          data.loginSignupModal ? "" : "hidden"
        } fixed z-40 inset-0 my-8 md:my-20 flex items-start justify-center overflow-auto rounded-3`}
      >
        <div className="w-11/12 md:w-3/5 lg:w-2/4 relative space-y-4 bg-white p-6 md:px-12 md:py-6 rounded-3">
        {newCollageValue ? <NewCollage/>: login ? <Login />: <Signup/> }   
          <div className="flex items-center space-x-2 rounded-3">
            <span className="border-b border-gray-500 w-full rounded-3" />
            <span className="font-medium">or</span>
            <span className="border-b border-gray-500 w-full rounded-3" />
          </div>

          <div
            onClick={(e) => changeLoginSignup()}
            style={{ color: "#303031", border: "1px solid #303031" }}
            className="px-4 py-2 font-medium text-center cursor-pointer rounded-3"
          >
            {loginValue}
          </div>
          {/* <div className="flex items-center space-x-2 rounded-3">
            <span className="border-b border-gray-500 w-full rounded-3" />
            <span className="font-medium">or</span>
            <span className="border-b border-gray-500 w-full rounded-3" />
          </div> */}
          { !newCollageValue && <div
            onClick={(e) => NotFromNie()}
            style={{ color: "#303031", border: "1px solid #303031" }}
            className="px-4 py-2 font-medium text-center cursor-pointer rounded-3"
          >
            If not from NIE,Mysore
          </div> }
          
          {/*  Modal Close Button */}

          <div className="absolute top-0 right-0 mx-4 rounded-3">
            <svg
              onClick={(e) => {
                loginSignupModalToggle();
                dispatch({ type: "loginSignupError", payload: false });
              }}
              className="w-6 h-6 cursor-pointer"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default LoginSignup;
